// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3T_Ut","name":"styles_name__2RGdS","phone":"styles_phone__2Mkp2"};